'use client';
import Image from 'next/image';

import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import { cn } from '@/lib/utils';

interface ArticleSliderProps {
  data: { alt: string; src: string; caption: string }[];
  className?: string;
}

export const ArticleSlider = ({ data, className }: ArticleSliderProps) => {
  return (
    <Carousel className={cn('relative grid', className)}>
      <CarouselContent>
        {data.map((item) => (
          <CarouselItem key={item.alt}>
            <div className="w-full max-w-full grid text-sm">
              <Image
                src={item.src}
                alt={item.alt}
                width={800}
                height={585}
                quality={75}
                sizes="(max-width: 768px) 100vw, 800px"
                className="w-full rounded-md object-cover h-[255px] lg:h-[585px] "
              />
              <p className="text-sm text-[#898989] mt-3 max-w-full w-max italic">{item?.caption}</p>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselDots />
      <CarouselPrevious className="absolute top-[48%] text-white -translate-y-1/2 left-4 size-8 lg:size-[60px] bg-black bg-opacity-30 backdrop-blur-[70px] border-0 hover:bg-black/40 hover:text-white lg:[&_svg]:size-6" />
      <CarouselNext className="absolute top-[48%] text-white -translate-y-1/2 right-4 size-8 lg:size-[60px] bg-black bg-opacity-30 backdrop-blur-[70px] border-0 hover:bg-black/40 hover:text-white lg:[&_svg]:size-6" />
    </Carousel>
  );
};
